import { styled } from "@mui/material/styles";
import { Box, Paper } from "@mui/material";
import { grey } from "@mui/material/colors";

export const CenteredContent = styled(Paper)(
  ({ theme }) => `
  background-color: white;
  flex: 1;
  padding-top: 1px;
  padding-bottom: ${theme.spacing(3)};
  padding-left: 0;
  padding-right: 0;
  margin-top: ${theme.spacing(3)};
  min-height: 50vh;
  border-radius: 6px;
  box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px;
`,
);

export const CenteredContentTitle = styled(Box)(
  ({ color, theme }) => `
  width: 100%;
  border-bottom: 1px solid ${color === "error" ? "#d32f2f54" : grey[300]};
  padding-left: ${theme.spacing(3)};
  padding-right: ${theme.spacing(3)};
  display: flex;
  height: 60px;
  align-items: center;
  justify-content: space-between;

  p {
    color: ${color === "error" ? theme.palette.error.main : grey[900]}
  }
`,
);

export const PageHeader = styled(Box)(
  ({ theme }) => `
  color: black;
  margin-top: ${theme.spacing(2)};
  margin-bottom: ${theme.spacing(5)};
  display: flex;
  justify-content: space-between;
  height: 40px;
  align-items: center;
`,
);

export const PageContainer = styled(Box)`
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
`;
